<template>
    <div class="tab_content">
        <div class="templete">
            <div class="search_box clearfix">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" @keyup.enter.native="getList(true)" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-select class="search_select search_inputBox" @keyup.enter.native="getList(true)" v-model="params.types" placeholder="类型">
                    <el-option :value="1" :label="'合包'"></el-option>
                    <el-option :value="2" :label="'拆包'"></el-option>
                </el-select>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.sn" placeholder="组装拆卸单号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.old_bale_no" placeholder="原包号"></el-input>
                <el-input class="search_input search_inputBox" @keyup.enter.native="getList(true)" v-model="params.new_bale_no" placeholder="新包号"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.breed" placeholder="品名" multiple @visible-change="getSelectList('assemblyBreed')" >
                    <el-option v-for="list in selectMap.assemblyBreed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <div class="searchBtnList clearfix">
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible;scene='assembly.list';isGlobal=false;filter=filter;"></div>
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="module.indexOf(',warehouse-combind-edit,')!=-1" @click="dialogVisible=!dialogVisible;sceneIn = 'assembly.create.column';isGlobal = true;getBillColumn();">新增</el-button>
            </div>
            <div class="tableBox">
                <tabletem :isSetCol="true" scene="assembly.list"  :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem>
                <!-- <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" @rowClick="rowClick"></tabletem> -->
            </div>
            <div class="totalCal no_print">
                <div class="totalNumber">合计：</div>
                <div class="totalNumber">{{totalObj}}单</div>
            </div> 
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
        </div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC eldialogBack eldialogTransfer eldialogWidth" :modal="false" :title="'组装拆卸'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <div class="outAndInTitle dialogForm">
                                待出库
                                <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisibleIn=!filterDialogVisibleIn;sceneIn = 'assembly.create.column';isGlobal = true;getBillColumn();"></div>
                            </div>
                            <el-table :data="form_params.out.detail" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrog">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="75" v-if="!isCanEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="toProduct()" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <template v-for="(item) in filters">
                                    <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                :sortable="false"
                                                :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                                align="left"
                                                show-overflow-tooltip
                                            >
                                        <template slot-scope="scope">
                                            <div v-if="item.field == 'original_width_total'">
                                                <span @click="widthList = scope.row.width;dialogVisibleWidth=true;isCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.original_width_total }}
                                                </span>
                                            </div>
                                             <div v-else-if="item.field == 'sales_total_width'">
                                                <span @click="widthList = scope.row.sales_width;saleDialogVisibleWidth=true;isSaleCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                                    {{ scope.row.sales_width_total }}
                                                </span>
                                            </div>
                                            <span v-else>
                                                {{ scope.row[item.field] }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>
                            </el-table>
                            <!-- <el-table :data="form_params.out.detail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="75" v-if="!isCanEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="dialogVisibleStock=!dialogVisibleStock" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.bale_no }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.breed }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.grade }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="属性" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',attribute,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.attribute }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="选色" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',color,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.color }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_thickness,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_thickness }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_length,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.original_length }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_width_total,')!=-1">
                                    <template slot-scope="scope">
                                        <span @click="widthList = scope.row.width;dialogVisibleWidth=true;isCanEditTotalWidth=false;" style="text-decoration:underline;cursor:pointer;">
                                            {{ scope.row.original_width_total }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.pieces }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.layer_number }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="码单立方" prop="original_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',original_cube,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.original_cube }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="采购单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',cube_price,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cube_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="成本平摊单价" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',cost,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.cost }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="挂牌价" width="95" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.sales_price }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="仓库" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',warehouse,')!=-1">
                                    <template slot-scope="scope">
                                        <span>
                                            {{ scope.row.warehouse }}
                                        </span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="103" show-overflow-tooltip v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.remark }}
                                    </template>
                                </el-table-column>
                            </el-table> -->
                            <div class="transferType" v-if="!isCanEdit">
                                <!-- <el-button :class="['transferBtn','funcPublicBtn',transferType==1?'':'funcPublicBtnChecked']" @click="handle(1)">组装</el-button> -->
                                <el-button :class="['transferBtn','funcPublicBtn',transferType==1?'funcPublicBtnChecked':'']" @click="handle(1)">组装</el-button>
                                <el-button :class="['transferBtn','funcPublicBtn',transferType==2?'funcPublicBtnChecked':'']" @click="handle(2)">拆卸</el-button>
                                <el-button class="gaugeBtn" @click="recheckRuler">重新检尺</el-button>
                                <!-- <input placeholder="输入拆卸的包数" type="number" class="transferNumberInput" @input="inputTransferNumber" v-model="transferNumber" v-if="transferType==2"/> -->
                            </div>
                            <div class="outAndInTitle"><span>待入库</span><span class="orangeFont" style="float: right;" v-if="!isCanEdit&&!categoryEdit">请分别检查宽度明细立方数与单据立方数是否一致！（以宽度明细计算方数为准）</span></div>
                                <el-table :data="form_params.in.detail" ref="listDetailTable" :row-class-name="tableRowClassName" :summary-method="getTableSummaries" border stripe show-summary highlight-current-row size="mini" height="100%" @header-dragend="headDrog" @selection-change="selectionDetailChange" @row-click="toggleSelection">
                                    <!-- <el-table-column type="index" label="序号" align="center" width="50"></el-table-column> -->
                                    <el-table-column type="selection"  :selectable="checkSelectable" width="50"></el-table-column>
                                    <template v-for="(item) in filters">
                                        <el-table-column :prop="item.field" v-if="item.show && billColumn.includes(item.field)" :key="item.field" :label="item.name"
                                                    :sortable="false"
                                                    :width="item.width && item.width>90 ?item.width:90+ 'px'"
                                                    align="left"
                                                    show-overflow-tooltip
                                                >
                                            <template slot-scope="scope">
                                                <div v-if="item.field == 'breed'">
                                                    <el-select  v-model="scope.row.breed_id" placeholder="品名" :disabled="isCanEdit" @visible-change="getSelectList('breed')" size="mini">
                                                        <el-option v-for="list in selectMap.breed" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'bale_no'">
                                                    <el-input v-model="scope.row.bale_no" :readonly="isCanEdit"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'grade'">
                                                    <el-select  v-model="scope.row.grade_id" placeholder="等级" :disabled="isCanEdit" @visible-change="getSelectList('grade')" size="mini">
                                                        <el-option v-for="list in selectMap.grade" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'attribute'">
                                                    <el-select  v-model="scope.row.attribute_id" placeholder="属性" :disabled="isCanEdit" @visible-change="getSelectList('attribute')" size="mini">
                                                        <el-option v-for="list in selectMap.attribute" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'color'">
                                                    <el-select  v-model="scope.row.color_id" placeholder="选色" :disabled="isCanEdit" @visible-change="getSelectList('color')" size="mini">
                                                        <el-option v-for="list in selectMap.color" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'original_length'">
                                                    <el-input v-model="scope.row.original_length" :readonly="isCanEdit" :disabled="(transferType==1&&scope.row.original_width_total?true:false)||(transferType==2&& !(scope.row.original_width_total=='0'||scope.row.original_width_total=='')?true:false)"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'original_thickness'">
                                                    <el-input v-model="scope.row.original_thickness" :readonly="isCanEdit" :disabled="(transferType==1&&scope.row.original_width_total?true:false)||(transferType==2 && !(scope.row.original_width_total=='0'||scope.row.original_width_total=='')?true:false)"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'original_width_total'">
                                                    <!-- indetailType=scope.$index;transferType==1?isCanEditTotalWidth=true:(scope.$index==0&&upodateType==2&&!isCanEdit)||(scope.$index==1&&upodateType==3&&!isCanEdit)?isCanEditTotalWidth=true:isCanEditTotalWidth=false; -->
                                                    <span @click="widthClick(scope.row,scope.$index)" style="text-decoration:underline;cursor:pointer;">
                                                        {{scope.row.original_width_total}}
                                                    </span>
                                                </div>
                                                <div v-else-if="item.field == 'sales_total_width'">
                                                    <!-- indetailType=scope.$index;transferType==1?isCanEditTotalWidth=true:(scope.$index==0&&upodateType==2&&!isCanEdit)||(scope.$index==1&&upodateType==3&&!isCanEdit)?isCanEditTotalWidth=true:isCanEditTotalWidth=false; -->
                                                    <span @click="salesWidthClick(scope.row,scope.$index)" style="text-decoration:underline;cursor:pointer;">
                                                        {{scope.row.sales_width_total}}
                                                    </span>
                                                </div>
                                                <div v-else-if="item.field == 'sales_cube'">
                                                    <el-input v-model="scope.row.sales_cube" @input="inDetailChangeSalesCube($event,scope.row,scope.$index)" :readonly="isCanEdit" :disabled="(transferType==1&& !(scope.row.sales_width_total=='0'||scope.row.sales_width_total==''))||(transferType==2&& !(scope.row.original_width_total=='0'||scope.row.original_width_total=='')?true:false)"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'pieces'">
                                                    <el-input v-model="scope.row.pieces" @input="inDetailChangePieces" :readonly="isCanEdit" :disabled="(transferType==1&&scope.row.original_width_total?true:false)||(transferType==2&& !(scope.row.original_width_total=='0'||scope.row.original_width_total=='')?true:false)"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'layer_number'">
                                                    <el-input v-model="scope.row.layer_number" @input="inDetailChangelayer" :readonly="isCanEdit" :disabled="(transferType==1&&scope.row.original_width_total?true:false)||(transferType==2&& !(scope.row.original_width_total=='0'||scope.row.original_width_total=='')?true:false)"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'original_cube'">
                                                    <!-- @input="inDetailChangeCube($event,scope.row,scope.$index)" -->
                                                    <!-- <el-input v-model="scope.row.original_cube"  readonly :disabled="(transferType==1&&scope.row.original_width_total?true:false)||(transferType==2&& !(scope.row.original_width_total=='0'||scope.row.original_width_total=='')?true:false)"></el-input> -->
                                                    <el-input v-model="scope.row.original_cube" @input="inDetailChangeCube($event,scope.row,scope.$index)" :readonly="isCanEdit" :disabled="(transferType==1&&scope.row.original_width_total?true:false)||(transferType==2&& !(scope.row.original_width_total=='0'||scope.row.original_width_total=='')?true:false)"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'check_cube'">
                                                    <!-- @input="inDetailCheck_cube"  -->
                                                    <!-- <el-input v-model="scope.row.check_cube" readonly :disabled="(transferType==1&&scope.row.original_width_total?true:false)||(transferType==2&& !(scope.row.original_width_total=='0'||scope.row.original_width_total=='')?true:false)"></el-input> -->
                                                    <el-input v-model="scope.row.check_cube"  disabled></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'cube_price'&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                                    <el-input v-model="scope.row.cube_price" :readonly="isCanEdit"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'cost'&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                                    <el-input v-model="scope.row.cost" :readonly="isCanEdit"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'sales_price'&&module.indexOf(',warehouse-combind-cost,')!=-1">
                                                    <el-input v-model="scope.row.sales_price" :readonly="isCanEdit"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'warehouse'">
                                                    <el-select  v-model="scope.row.warehouse_id" placeholder="仓库" :disabled="isCanEdit" @visible-change="getSelectList('warehouse')" size="mini">
                                                        <el-option v-for="list in selectMap.warehouse" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                                    </el-select>
                                                </div>
                                                <div v-else-if="item.field == 'remark'">
                                                    <el-input v-model="scope.row.remark" :readonly="isCanEdit"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'weight'">
                                                    <el-input v-model="scope.row.weight" :readonly="isCanEdit"></el-input>
                                                </div>
                                                 <div v-else-if="item.field == 'one_width'">
                                                    <el-input v-model="scope.row.one_width" :readonly="isCanEdit"></el-input>
                                                </div>
                                                <div v-else-if="item.field == 'zel_total_width'">
                                                    <el-input v-model="scope.row.zel_total_width" :readonly="isCanEdit"></el-input>
                                                </div>
                                                 <div v-else-if="item.field == 'avg_width'">
                                                    <el-input v-model="scope.row.avg_width" :readonly="isCanEdit"></el-input>
                                                </div>
                                                <span v-else>
                                                    {{ scope.row[item.field] }}
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </template>
                                </el-table>
                        </div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5" :readonly="isCanEdit"></textarea>
                    </div>
                    <div v-if="isCanEdit" class="flex">
                        <div>单据日期：{{form_params.order_time}}</div>
                        <div>制单人：{{form_params.creator_name}}</div>
                    </div>
                </div>
                <div class="editBtnList clearfix" v-if="!isCanEdit">
                    <div class="editBtn">
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="transferConfirm">确认</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->

        <!--选择库存START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleStock" class="eldialog eldialogStock" width="1160px" :modal="false" title="选择货物" custom-class="full_dialog">
            <transfer-select-stock ref="selectStock" @cancel="dialogVisibleStock=!dialogVisibleStock" @selectData="selectData" @selectAndOut="selectAndOut"></transfer-select-stock>
        </el-dialog>
        <!--选择库存END-->
        <!-- 宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isCanEditTotalWidth" :codeSheetType="2" :dialogvisible="dialogVisibleWidth" :list="widthList" @returnIs_sales="res=>{returnIs_sales(res)}" @returnwidth="res=>{widthReturn(res)}" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 宽度列表END -->
        <!-- 销售宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="saleDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isSaleCanEditTotalWidth" :dialogvisible="saleDialogVisibleWidth" :list="widthList" @returnwidth="res=>{saleWidthReturn(res)}" :type="1"  @cancelWidth="()=>{this.saleDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 销售宽度列表END -->
        <!-- 检尺销售宽度列表START -->
        <el-dialog v-dialog-drag :visible.sync="saleRulerDialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
            <total-widthnew :edit="isSaleCanEditTotalWidth" :dialogvisible="saleRulerDialogVisibleWidth" :list="widthList" @returnwidth="res=>{saleRulerWidthReturn(res)}" :type="1"  @cancelWidth="()=>{this.saleRulerDialogVisibleWidth = false;}"></total-widthnew>
        </el-dialog>
        <!-- 检尺销售宽度列表END -->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="assembly.list" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <!-- 单据里面列配置 START -->
        <filter-fields :tableData="filters" scene="assembly.create.column" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisibleIn" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisibleIn = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <el-dialog v-dialog-drag :visible.sync="rulerSpringFrame" class="eldialog eldialogLine" :modal="false" title="重新检尺" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="rulerForm" class="clearfix dialogFormB">
                    <el-form-item  label="捆包号：">
                        <el-input v-model="rulerForm.bale_no" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="码单立方：">
                        <el-input v-model="rulerForm.original_cube" disabled></el-input>
                    </el-form-item>
                    <el-form-item  label="检尺立方：">
                        <el-input v-model="rulerForm.check_cube" @input="chiCheckCube"></el-input>
                    </el-form-item>
                    <el-form-item  label="销售立方：">
                        <el-input v-model="rulerForm.sales_cube"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="rulerSpringFrame=!rulerSpringFrame" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" @click="newRuler">确认</el-button>
                    </div>
                    <div class="beCareful" v-if="this.form_params.in.detail.length==2 && (this.selectionDetailRow[0] && this.selectionDetailRow[0].indexs==0)">
                        注意:第二包请手动勾选检尺~！
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!-- 同步销售总宽度 START -->
        <el-dialog v-dialog-drag :visible.sync="salesEditDialog" class="eldialog eldialogOneLabel totalChangeWidth spec" width="300px" :modal="false" title="是否确定修改" custom-class="full_dialog">
            <div class="whole">
                <el-checkbox v-model="is_sales"
                         class="confirmCheckBox">修改数据同步到销售宽度明细
                </el-checkbox>
            </div>
            <div class="dialogBtnList clearfix">
                <el-button  class="publicBtn dialogBtn" @click="widthEdit(salesEditContent)">确定</el-button>
                <el-button class="dialogBtn funcPublicBtn" @click="salesEditDialog = false">取消</el-button>
            </div>
        </el-dialog>
        <!-- 同步销售总宽度 END -->
    </div>
</template>
<script>
    import bus from "../../eventBus";
    import tabletem from '../../components/table.vue'
    import pagination from '../../components/pagination.vue'
    export default {
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                dialogVisibleWidth:false,
                saleDialogVisibleWidth:false,//销售总宽弹框
                saleRulerDialogVisibleWidth:false,//销售检尺弹框
                isSaleCanEditTotalWidth:false,
                widthList:[],
                filter:[],
                filters:[],
                filterDialogVisibleIn:false,
                filterDialogVisible:false,
                isGlobal:false,
                billColumn:"",
                sceneIn:"assembly.create.column",
                scene:"assembly.list",
                copy_filter:"",
                isCanEditTotalWidth:false,
                upodateType:2,
                indetailType:"",
                start_time:"",
                end_time:"",
                params:{
                    start_time:"",
                    end_time:"",
                    sn:"",
                    types:"",
                    page:1,
                    per_page:50,
                    breed:'',
                    old_bale_no:'',
                    new_bale_no:'',
                },
                breedList:[],
                gradeList:[],
                warehouseList:[],
                selectMap:{
                    breed:[],
                    grade:[],
                    warehouse:[],
                    attribute:[],
                    color:[],
                    assemblyBreed:[]
                },
                dialogVisible:false,
                centerDialogVisible:false,
                dialogVisibleStock:false,
                last_page:1,
                total:0,
                selectRow:[],
                form_params:{
                    out:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                width:[
                                    {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[],width_other:""}
                                ],
                                pieces:"",
                                original_cube:"",
                                check_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:"",
                                color:"",
                                attribute:"",
                                sales_price:"",
                                weight:"",
                                one_width:"",
                                zel_total_width:"",
                                avg_width:"",
                            }
                        ]
                    },
                    in:{
                        detail:[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                color_id:"",
                                attribute_id:"",
                                sales_price:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                width:[
                                   {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[],width_other:""}
                                ],
                                pieces:"",
                                original_cube:"",
                                check_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:"",
                                indexs:"",
                                is_sales:'',
                                weight:"",
                                one_width:"",
                                zel_total_width:"",
                                avg_width:"",
                            }
                        ]
                    },
                    remark:""
                },
                isCanEdit:false,
                transferNumber:"",
                transferType:"",//1.组装 2.拆卸
                list:[],
                tableCol:[
                    {colName:"单据日期",colKey:"order_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"单据编号",colKey:"ad_no",colWidth:150,isSetWidth:true,isCanClick:true,isShow:true,isColor:true},
                    {colName:"类型",colKey:"type_text",colWidth:60,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"审核人",colKey:"auditor_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"新包号",colKey:"new_bale_no",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"原包号",colKey:"old_bale_no",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"品名",colKey:"breed",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}
                ],
                totalObj:{},
                listDetail:[],
                errorMessage:"",
                flag:false,
                removeTotalOriginal:"",
                removeSalesWidthTotalOriginal:"",
                removeOriginal:"",
                removeSalesWidthOriginal:"",
                removeThicknessOriginal:"",
                removeLengthOriginal:"",
                removePiecesOriginal:"",
                isShowEdit:false,
                sameType:0,//选择货物类型 1非洲材同规格 0 非洲材不同规格
                rulerSpringFrame:false,//坚持弹框
                rulerForm:{
                    bale_no:"",
                    original_cube:"",
                    check_cube:"",
                    sales_cube:"",
                },
                selectionDetailRow:[],
                selectionDetailIndex:'',//选中下标
                check:0,
                is_sales:true,
                salesEditDialog:false,
                salesEditContent:[],
                decimalNum:Number(localStorage.getItem('dm_erp_decimal_scale')),
                categoryEdit:true,
                selectStatus:0,
            }
        },
        created(){
            this.getSelectList("breed")
            this.getSelectList("grade")
            this.getSelectList("warehouse")
            this.getSelectList("attribute")
            this.getSelectList("color")
             this.getSelectList("assemblyBreed")
            this.tableColCopy = this.$deepClone(this.tableCol);
            this.getList()
            this.getBillColumn()
        },
        methods:{
            headDrog(newWidth, oldWidth, column) {
                this.filters.forEach((item) => {
                    if (column.property == item.colKey) {
                        item.colWidth = newWidth;
                    }
                });
                let obj = {};
                obj.width = parseInt(newWidth);
                obj.name = column.property;
                let emit = ("changeHeadWidth" + this.sceneIn).replace(/\./g, "");
                bus.$emit(emit, obj);
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                if(this.isGlobal){
                    this.filters=[]
                    this.postFunc("/erp/company.column.data",{scene:this.sceneIn},response=>{
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filters = response.data.data.columns;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{
                    this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                        this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                        this.filter = response.data.data.columns;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }
            },
            getTableSummaries(params) {
                return this.$setSummaryFields(params, {
                    original_cube: 4,//码单立方
                    check_cube:4,
                    sales_cube:4,
                },total=>{
                });
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=JSON.parse(JSON.stringify(res.list));
                })
            },
            //实时片数
            inDetailChangePieces(val){
                if(Number(val)||Number(val)==0){
                    for(let i=0;i<this.form_params.in.detail.length;i++){
                        if(this.form_params.in.detail[i].pieces!=val){
                            this.form_params.in.detail[i].pieces = Number(this.form_params.out.detail[0].pieces)-Number(val)
                        }
                    }
                }
            },
            //实时层数
            inDetailChangelayer(val){
                if(!this.isShowEdit){
                    if(Number(val)||Number(val)==0){
                        for(let i=0;i<this.form_params.in.detail.length;i++){
                            if(this.form_params.in.detail[i].layer_number!=val){
                                this.form_params.in.detail[i].layer_number = Number(this.form_params.out.detail[0].layer_number)-Number(val)
                            }
                        }
                    }
                }
            },
            //码单立方输入
            inDetailChangeCube(num,row,index){
                let val = this.$cloneJson(this.$digitInput(num, this.decimalNum,true,true));
                if(this.transferType==1){
                    this.form_params.in.detail[0].original_cube = val;
                }else{
                    if(!this.isShowEdit){
                        if(Number(val)||Number(val)==0){
                            for(let i=0;i<this.form_params.in.detail.length;i++){
                                // 判断输入条和本条相同保留输入多少位数
                                if(index == i){
                                    this.form_params.in.detail[i].original_cube = val;
                                }else{
                                    if(this.form_params.in.detail[i].original_cube!=val){
                                        this.form_params.in.detail[i].original_cube = this.$bc_sub(this.form_params.out.detail[0].original_cube,val)                               
                                    }else if((this.form_params.in.detail[0].original_cube==this.form_params.in.detail[1].original_cube)
                                        &&(this.form_params.out.detail[0].original_cube!=(Number(this.form_params.in.detail[0].original_cube)+ this.form_params.in.detail[1].original_cube))){
                                        this.form_params.in.detail[i].original_cube = this.$bc_sub(this.form_params.out.detail[0].original_cube,val)
                                    }
                                }
                            }
                            if(this.form_params.out.detail.length==1&&this.transferType==2){
                                let originalOut = this.form_params.out.detail[0].original_cube;//原包码单立方
                                let salesOut = this.form_params.out.detail[0].sales_cube;//原包销售立方
                                let checkOut = this.form_params.out.detail[0].check_cube;//原包检尺立方
                                this.form_params.in.detail.forEach((item,index)=>{
                                    item.sales_cube = this.keepLimitNum(this.$bc_mul(this.$bc_div(item.original_cube,originalOut),salesOut))
                                    item.check_cube = this.keepLimitNum(this.$bc_mul(this.$bc_div(item.original_cube,originalOut),checkOut))
                                })
                            }
                        }
                    }
                }
            },
            //销售立方输入
            inDetailChangeSalesCube(num,row,index){
                let val = this.$cloneJson(this.$digitInput(num, this.decimalNum,true,true));
                if(this.transferType==1){
                    this.form_params.in.detail[0].sales_cube = val;
                }else{
                    if(!this.isShowEdit){
                        if(Number(val)||Number(val)==0){
                            for(let i=0;i<this.form_params.in.detail.length;i++){
                                // 判断输入条和本条相同保留输入多少位数
                                if(index == i){
                                    this.form_params.in.detail[i].sales_cube = val;
                                }else{
                                    if(this.form_params.in.detail[i].sales_cube!=val){
                                        this.form_params.in.detail[i].sales_cube = this.$bc_sub(this.form_params.out.detail[0].sales_cube,val)                               
                                    }else if((this.form_params.in.detail[0].sales_cube==this.form_params.in.detail[1].sales_cube)
                                            &&(this.form_params.out.detail[0].sales_cube!=(this.form_params.in.detail[0].sales_cube+this.form_params.in.detail[1].sales_cube))){
                                        this.form_params.in.detail[i].sales_cube = this.$bc_sub(this.form_params.out.detail[0].sales_cube,val)
                                    }
                                }
                            }
                            if(this.form_params.out.detail.length==1&&this.transferType==2){
                                let originalOut = this.form_params.out.detail[0].original_cube;//原包码单立方
                                let salesOut = this.form_params.out.detail[0].sales_cube;//原包销售立方
                                let checkOut = this.form_params.out.detail[0].check_cube;//原包检尺立方
                                this.form_params.in.detail.forEach((item,index)=>{
                                    item.original_cube = this.keepLimitNum(this.$bc_mul(this.$bc_div(item.sales_cube,salesOut),originalOut))
                                    // item.check_cube = this.keepLimit(this.$bc_mul(this.$bc_div(item.original_cube,originalOut),checkOut))
                                    item.check_cube = this.keepLimitNum(this.$bc_mul(this.$bc_div(item.sales_cube,salesOut),checkOut))
                                })
                            }
                        }
                    }
                }
            },
            inDetailCheck_cube(val){
                if(!this.isShowEdit){
                    if(Number(val)||Number(val)==0){
                       for(let i=0;i<this.form_params.in.detail.length;i++){
                           if(this.form_params.in.detail[i].check_cube!=val){
                               this.form_params.in.detail[i].check_cube = this.keepLimit(this.keepLimit(this.form_params.out.detail[0].check_cube)-this.keepLimit(val))
                           }
                       }
                    }
                }
            },
            inputTransferNumber(val){
                let value = parseInt(val.target.value)
                let flag = this.handle();
                if(flag){
                    this.form_params.in.detail=[];
                    for(let i=0;i<value;i++){
                        this.form_params.in.detail.push(JSON.parse(JSON.stringify(this.form_params.out.detail[0])))
                    }
                }
            },
            transferConfirm(){
                // if(this.form_params.out.detail[0].category_id==1&&this.form_params.out.detail[0].check_cube!=0&&this.check==0){
                //         this.$confirm('原捆包有检尺立方是否需要检尺~！', '提示', {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     }).then(()=>{
                //         this.rulerSpringFrame = !this.rulerSpringFrame;
                //         this.rulerForm.bale_no = this.selectionDetailRow[0].bale_no;
                //         this.rulerForm.original_cube = this.selectionDetailRow[0].original_cube;
                //         this.rulerForm.check_cube = this.selectionDetailRow[0].check_cube;
                //         this.rulerForm.sales_cube = this.selectionDetailRow[0].sales_cube;
                //     }).catch(()=>{
                //         this.$confirm('是否确认操作?', '提示', {
                //         confirmButtonText: '确定',
                //         cancelButtonText: '取消',
                //         type: 'warning'
                //     }).then(() => {
                //         let flag = this.handle();
                //         if(flag){
                //             let obj = new Object();
                //             obj.types=this.transferType;
                //             obj.order_time=this.formatTimeZero(new Date())
                //             obj.ids=[];
                //             this.form_params.out.detail.forEach(item=>{
                //                 obj.ids.push(item.id)
                //             })
                            
                //             obj.news=JSON.parse(JSON.stringify(this.form_params.in.detail));
                //             obj.remark = this.form_params.remark;
    
                //             this.selectMap.breed.forEach(item=>{
                //                 if(item.id == obj.news[0].breed_id){
                //                     obj.news[0].breed = item.name
                //                 }
                //             })
                //             this.selectMap.color.forEach(item=>{
                //                 if(item.id == obj.news[0].color_id){
                //                     obj.news[0].color = item.name
                //                 }
                //             })
                //             this.selectMap.grade.forEach(item=>{
                //                 if(item.id == obj.news[0].grade_id){
                //                     obj.news[0].grade = item.name
                //                 }
                //             })
                //             this.selectMap.attribute.forEach(item=>{
                //                 if(item.id == obj.news[0].attribute_id){
                //                     obj.news[0].attribute = item.name
                //                 }
                //             })
                //             this.postFuncLoading("/erp/assembly.create",obj,()=>{
                //                 this.tip("操作成功","success")
                //                 this.dialogVisible=false;
                //                 this.getList()
                //             },error=>{
                //                 this.tip(error.data.message,"warning")
                //             })
                //         }
                //     }).catch(()=>{});
                //     });
                // }else{
                    if(this.transferType==1){
                        if( this.form_params.in.detail[0].original_cube<0||
                        this.form_params.in.detail[0].sales_cube<0){
                            this.tip("立方数不能为负数","warning")
                            return
                        }
                        if( this.form_params.in.detail[0].original_cube==0||
                        this.form_params.in.detail[0].sales_cube==0){
                            this.tip("立方数不能为0","warning")
                            return
                        }
                    }else{
                        if( this.form_params.in.detail[0].original_cube<0|| this.form_params.in.detail[1].original_cube<0||
                        this.form_params.in.detail[0].sales_cube<0||this.form_params.in.detail[1].sales_cube<0){
                            this.tip("立方数不能为负数","warning")
                            return
                        }
                        if( this.form_params.in.detail[0].original_cube==0|| this.form_params.in.detail[1].original_cube==0||
                        this.form_params.in.detail[0].sales_cube==0||this.form_params.in.detail[1].sales_cube==0){
                            this.tip("立方数不能为0","warning")
                            return
                        }
                    }
                    this.$confirm('是否确认操作?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        let flag = this.handle();
                        if(flag){
                            let obj = new Object();
                            obj.types=this.transferType;
                            obj.order_time=this.formatTimeZero(new Date())
                            obj.ids=[];
                            this.form_params.out.detail.forEach(item=>{
                                obj.ids.push(item.id)
                            })
                            
                            obj.news=JSON.parse(JSON.stringify(this.form_params.in.detail));
                            obj.remark = this.form_params.remark;
    
                            this.selectMap.breed.forEach(item=>{
                                if(item.id == obj.news[0].breed_id){
                                    obj.news[0].breed = item.name
                                }
                            })
                            this.selectMap.color.forEach(item=>{
                                if(item.id == obj.news[0].color_id){
                                    obj.news[0].color = item.name
                                }
                            })
                            this.selectMap.grade.forEach(item=>{
                                if(item.id == obj.news[0].grade_id){
                                    obj.news[0].grade = item.name
                                }
                            })
                            this.selectMap.attribute.forEach(item=>{
                                if(item.id == obj.news[0].attribute_id){
                                    obj.news[0].attribute = item.name
                                }
                            })
                            this.postFuncLoading("/erp/assembly.create",obj,()=>{
                                this.tip("操作成功","success")
                                this.dialogVisible=false;
                                this.getList()
                            },error=>{
                                this.tip(error.data.message,"warning")
                            })
                        }
                    }).catch(()=>{});
                // }
            },
            handle(type){
                if(this.form_params.out.detail[0].category_id==2){
                    this.categoryEdit = false;
                }
                if(type){
                    this.transferType=type;
                    this.isCanEditTotalWidth = true;
                    this.upodateType = 2;
                    type == 1 ? this.isShowEdit = true : this.isShowEdit = false
                }
                if(this.form_params.out.detail.length<=1&&this.form_params.out.detail[0].id==""){
                    this.tip("请选择货物","warning");
                    this.flag=false;
                    this.errorMessage="请选择货物";
                    return false;
                }else{
                    if(this.transferType==2){
                        if(this.form_params.out.detail.length>1){
                            this.tip("拆卸只能选择一件货物","warning");
                            this.flag=false;
                            this.errorMessage="拆卸只能选择一件货物";
                            return false;
                        }
                    }
                }
                if(type==1){
                    this.form_params.in.detail=[];
                    this.form_params.in.detail.push(JSON.parse(JSON.stringify(this.form_params.out.detail[0])))
                    let original_cube = 0;
                    let sales_cube = 0;
                    let check_cube = 0;
                    let pieces = null;
                    let layer_number = 0;
                    let original_length = "";
                    let original_thickness = "";
                    let width = [];
                    let sales_width = [];
                    let widthDetail = [];
                    let saleswidthDetail = [];
                    let flag = true;
                    this.form_params.out.detail.forEach((item,index)=>{
                        if(index<this.form_params.out.detail.length-1){
                            if(item.original_thickness==this.form_params.out.detail[index+1].original_thickness&&item.original_length==this.form_params.out.detail[index+1].original_length){
                                flag = false;
                            }
                        }
                    })
                    if(flag){
                        pieces = "";
                    }
                    let oldPrice = 0;
                    let oldCost = 0;
                    this.form_params.out.detail.forEach(item=>{
                        original_cube += Number(item.original_cube)
                        sales_cube += Number(item.sales_cube)
                        check_cube += Number(item.check_cube)
                        oldPrice += (item.cube_price * item.original_cube)
                        oldCost += (item.cost * item.original_cube)
                        if(flag){
                            pieces+=item.pieces?item.pieces+",":"";
                            original_length+=item.original_length?item.original_length+",":"";
                            original_thickness+=item.original_thickness?item.original_thickness+",":"";
                        }else{
                            pieces+=Number(item.pieces);
                        }
                        layer_number+=Number(item.layer_number)
                        if(flag){
                            width = width.concat(item.width)
                            sales_width = sales_width.concat(item.sales_width)
                        }else{
                            item.width.forEach(wid=>{
                                widthDetail = widthDetail.concat(wid.width)
                            })
                            item.sales_width.forEach(wid=>{
                                saleswidthDetail = saleswidthDetail.concat(wid.width)
                            })
                        }
                    })
                    if(flag){
                        this.form_params.in.detail[0].pieces = pieces.substring(0,pieces.length-1);
                        this.form_params.in.detail[0].original_length = original_length.substring(0,original_length.length-1);
                        this.form_params.in.detail[0].original_thickness =  original_thickness.substring(0,original_thickness.length-1);
                    }else{
                        this.form_params.in.detail[0].pieces = pieces;
                        this.form_params.in.detail[0].original_length = this.form_params.out.detail[0].original_length;
                        this.form_params.in.detail[0].original_thickness = this.form_params.out.detail[0].original_thickness;
                    }
                    this.form_params.in.detail[0].check_cube = this.keepLimit(check_cube);
                    // this.form_params.in.detail[0].check_cube = 0;
                    this.form_params.in.detail[0].sales_cube = this.keepLimit(sales_cube);
                    this.form_params.in.detail[0].original_cube = this.keepLimit(original_cube);
                    this.form_params.in.detail[0].cube_price = this.keepPrice(oldPrice / original_cube);
                    this.form_params.in.detail[0].cost = this.keepPrice(oldCost / original_cube);
                    this.form_params.in.detail[0].layer_number = layer_number;
                    this.form_params.in.detail[0].remark = "合包";
                    this.form_params.in.detail[0].bale_no = this.form_params.out.detail[0].bale_no+"+1";
                    this.form_params.in.detail[0].avg_width = this.form_params.out.detail[0].avg_width?this.form_params.out.detail[0].avg_width:'';
                    this.form_params.in.detail[0].zel_total_width = this.form_params.out.detail[0].zel_total_width?this.form_params.out.detail[0].zel_total_width:'';
                    this.form_params.in.detail[0].weight = this.form_params.out.detail[0].weight?this.form_params.out.detail[0].weight:'';
                    this.form_params.in.detail[0].one_width = this.form_params.out.detail[0].one_width?this.form_params.out.detail[0].one_width:'';
                    this.$nextTick(() => {
                        for (let i = 0; i < this.form_params.in.detail.length; i++) {
                            this.$refs.listDetailTable.toggleRowSelection(
                                this.form_params.in.detail[0],
                            true
                            );
                        }
                    });
                    this.check = 0;
                    // original_cube  cube_price  cost
                    // this.form_params.in.detail[0].width = this.form_params.out.detail[0].width.concat(this.form_params.out.detail[1].width)
                    if(flag){
                        this.sameType = 2
                        this.form_params.in.detail[0].width = width;
                        this.form_params.in.detail[0].sales_width = sales_width;
                    }else{
                        this.sameType = 1
                        this.form_params.in.detail[0].width[0].width = widthDetail;
                        this.form_params.in.detail[0].width[0].sales_width = saleswidthDetail;
                    }
                    this.calculation(0)
                }else if(type==2){
                    this.transferNumber=2;
                    this.form_params.in.detail=[];
                    this.form_params.in.detail.push(JSON.parse(JSON.stringify(this.form_params.out.detail[0])))
                    this.form_params.in.detail.push(JSON.parse(JSON.stringify(this.form_params.out.detail[0])))
                    // this.form_params.in.detail[0].check_cube=this.keepLimit(this.form_params.out.detail[0].check_cube/2)
                    this.form_params.in.detail[0].check_cube= 0;
                    this.form_params.in.detail[0].sales_cube= this.keepLimit(this.form_params.out.detail[0].sales_cube/2);
                    this.form_params.in.detail[0].original_cube=this.keepLimit(this.form_params.out.detail[0].original_cube/2)
                    // this.form_params.in.detail[0].pieces=parseInt(this.form_params.out.detail[0].pieces/2)
                    this.form_params.in.detail[0].layer_number=parseInt(this.form_params.out.detail[0].layer_number/2)
                    this.form_params.in.detail[0].remark = "拆包";
                    // this.form_params.in.detail[1].check_cube= this.keepLimit(this.form_params.out.detail[0].check_cube - this.form_params.in.detail[0].check_cube)
                    this.form_params.in.detail[1].check_cube= 0;
                    this.form_params.in.detail[1].sales_cube= this.keepLimit(this.form_params.out.detail[0].sales_cube - this.form_params.in.detail[0].sales_cube);
                    this.form_params.in.detail[1].original_cube= this.keepLimit(this.form_params.out.detail[0].original_cube - this.form_params.in.detail[0].original_cube)
                    // this.form_params.in.detail[1].pieces=Math.ceil(this.form_params.out.detail[0].pieces/2)
                    this.form_params.in.detail[1].layer_number=Math.ceil(this.form_params.out.detail[0].layer_number/2)
                    this.form_params.in.detail[1].remark = "拆包";
                    this.form_params.in.detail[0].bale_no = this.form_params.out.detail[0].bale_no+"-1";
                    this.form_params.in.detail[1].bale_no = this.form_params.out.detail[0].bale_no+"-2";
                    this.form_params.in.detail[0].width = JSON.parse(JSON.stringify(this.form_params.out.detail[0].width));
                    this.form_params.in.detail[1].width = JSON.parse(JSON.stringify(this.form_params.out.detail[0].width));
                    this.form_params.in.detail[0].sales_width = JSON.parse(JSON.stringify(this.form_params.out.detail[0].sales_width));
                    this.form_params.in.detail[1].sales_width = JSON.parse(JSON.stringify(this.form_params.out.detail[0].sales_width));

                    this.form_params.in.detail[0].avg_width = this.form_params.out.detail[0].avg_width?this.form_params.out.detail[0].avg_width:'';
                    this.form_params.in.detail[0].zel_total_width = this.form_params.out.detail[0].zel_total_width?this.form_params.out.detail[0].zel_total_width:'';
                    this.form_params.in.detail[0].weight = this.form_params.out.detail[0].weight?this.form_params.out.detail[0].weight:'';
                    this.form_params.in.detail[0].one_width = this.form_params.out.detail[0].one_width?this.form_params.out.detail[0].one_width:'';
                    this.form_params.in.detail[1].avg_width = this.form_params.out.detail[0].avg_width?this.form_params.out.detail[0].avg_width:'';
                    this.form_params.in.detail[1].zel_total_width = this.form_params.out.detail[0].zel_total_width?this.form_params.out.detail[0].zel_total_width:'';
                    this.form_params.in.detail[1].weight = this.form_params.out.detail[0].weight?this.form_params.out.detail[0].weight:'';
                    this.form_params.in.detail[1].one_width = this.form_params.out.detail[0].one_width?this.form_params.out.detail[0].one_width:'';

                    this.removeTotalOriginal = this.form_params.out.detail[0].original_width_total;
                    this.removeSalesWidthTotalOriginal = this.form_params.out.detail[0].sales_width_total;
                    this.removeOriginal = JSON.parse(JSON.stringify(this.form_params.out.detail[0].width));
                    this.removeSalesWidthOriginal = JSON.parse(JSON.stringify(this.form_params.out.detail[0].sales_width));
                    this.$nextTick(() => {
                    for (let i = 0; i < this.form_params.in.detail.length; i++) {
                            this.$refs.listDetailTable.toggleRowSelection(
                                this.form_params.in.detail[0],
                            true
                            );
                            //  this.form_params.in.detail[i].indexs =i
                        }
                    });
                    this.check = 0;
                    this.form_params.in.detail[0].indexs = 0;
                    this.form_params.in.detail[1].indexs = 1;
                    this.removeThicknessOriginal = this.form_params.out.detail[0].original_thickness;
                    this.removeLengthOriginal = this.form_params.out.detail[0].original_length;
                    this.removePiecesOriginal = this.form_params.out.detail[0].pieces;
                    if(this.form_params.out.detail[0].category_id==2){
                        this.postFunc("/erp/system.get.config",{key:"ASSEMBLY_WIDTH_SPLIT"},res=>{
                            this.selectStatus = res.data.data.status;
                            if(res.data.data.status==0){
                                // this.form_params.in.detail[0].sales_cube= this.keepLimit(this.form_params.out.detail[0].sales_cube/2);
                                // this.form_params.in.detail[0].original_cube=this.keepLimit(this.form_params.out.detail[0].original_cube/2)
                                // this.form_params.in.detail[1].sales_cube= this.keepLimit(this.form_params.out.detail[0].sales_cube - this.form_params.in.detail[0].sales_cube);
                                // this.form_params.in.detail[1].original_cube= this.keepLimit(this.form_params.out.detail[0].original_cube - this.form_params.in.detail[0].original_cube)
                        
                                if(this.form_params.out.detail[0].width.length==1){
                                    this.form_params.in.detail[0].original_width_total = parseInt(this.form_params.out.detail[0].original_width_total/2);
                                    this.form_params.in.detail[1].original_width_total = parseInt(this.form_params.out.detail[0].original_width_total/2);
                                    this.form_params.in.detail.forEach(item=>{
                                        item.width.forEach(newItem=>{
                                            newItem.newWidth =newItem.width.reduce(function(a, b){
                                                if(b){
                                                    return Number(a) + Number(b); //宽度明细合计
                                                }else{
                                                    return Number(a); //宽度明细合计
                                                }
                                            }, 0); 
                                            newItem.width = [newItem.newWidth/2];
                                        })
                                    })
                                }
                                if(this.form_params.out.detail[0].sales_width.length==1){
                                    this.form_params.in.detail[0].sales_width_total = parseInt(this.form_params.out.detail[0].sales_width_total/2);
                                    this.form_params.in.detail[1].sales_width_total = parseInt(this.form_params.out.detail[0].sales_width_total/2);
                                    this.form_params.in.detail.forEach(item=>{
                                        item.sales_width.forEach(newItem=>{
                                            newItem.newWidth =newItem.width.reduce(function(a, b){
                                                if(b){
                                                    return Number(a) + Number(b); //宽度明细合计
                                                }else{
                                                    return Number(a); //宽度明细合计
                                                }
                                            }, 0); 
                                            newItem.width = [newItem.newWidth/2];
                                        })
                                    })
                                }
                            }else if(res.data.data.status==1){
                                this.form_params.in.detail[0].sales_cube= this.keepLimit(this.form_params.out.detail[0].sales_cube);
                                this.form_params.in.detail[0].original_cube=this.keepLimit(this.form_params.out.detail[0].original_cube);
                                this.form_params.in.detail[1].sales_cube= this.keepLimit(this.form_params.out.detail[0].sales_cube);
                                this.form_params.in.detail[1].original_cube=this.keepLimit(this.form_params.out.detail[0].original_cube)
                            }
                        },error=>{
                            this.tip(error.data.message,"warning")
                        })
                    }
                    
                }
                return true;
            },
            calculationTotalWidth(formNumber){
                let total = "";
                let countWidth = "";
                let layer_number = "";
                this.form_params.in.detail[formNumber].width.forEach((item,index)=>{
                    if(this.sameType == 1){
                        if(item.width_other!=undefined){
                            countWidth = item.width_other;
                        }
                        layer_number = item.layer_number;
                        total += !!item.width&&item.width.length>0?item.width.reduce((prev,next)=> Number(prev)+Number(next)):""
                        total += !!item.width&&item.width.length>0?",":"";
                    }else{
                        // let width_other = JSON.parse(JSON.stringify(item.width_other));
                        // if(item.layer_number){//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数、
                            let layer_number = JSON.parse(JSON.stringify(item.layer_number));
                            if(item.width_other==''||item.width_other==undefined){
                                total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                                total += !!item.width&&item.width.length>0?",":"";
                            }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                                if(layer_number!=''){
                                    total += !!item.width&&item.width.length>0?
                                    this.rounding(this.$bc_add(this.$bc_mul(this.$bc_div(this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))),item.width.length),item.layer_number),item.width_other))
                                    :"";
                                    total += !!item.width&&item.width.length>0?",":"";
                                }else{
                                    total = item.width_other;
                                    total += !!item.width&&item.width.length>0?",":"";
                                }
                            }
                        // }else{
                            //     total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                        //     total += !!item.width&&item.width.length>0?",":"";
                        // }
                    }
                })
                if(this.sameType == 1){
                    if(layer_number==0){
                        total = String(this.keepLimit(total.substring(0,total.length-1)));
                    }else{
                        if(countWidth){
                            total = String(this.keepLimit(total.substring(0,total.length-1)/countWidth*(layer_number?layer_number:1)));
                        }else{
                            total = String(this.keepLimit(total.substring(0,total.length-1)));
                        }
                    }
                }else{
                    total = String((total.substring(0,total.length-1)));
                }
                this.form_params.in.detail[formNumber].original_width_total = total;
            },
            //销售总宽度
            calculationSalesWidthTotalWidth(formNumber){
                let total = "";
                let countWidth = "";
                let layer_number = "";
                this.form_params.in.detail[formNumber].sales_width.forEach((item,index)=>{
                    if(item.layer_number==undefined){
                        item.layer_number=''
                    }
                    if(this.sameType == 1){
                        if(item.width_other!=undefined){
                            countWidth = item.width_other;
                        }
                        layer_number = item.layer_number;
                        total += !!item.width&&item.width.length>0?item.width.reduce((prev,next)=> Number(prev)+Number(next)):""
                        total += !!item.width&&item.width.length>0?",":"";
                    }else{
                        // let width_other = JSON.parse(JSON.stringify(item.width_other));
                        // if(item.layer_number){//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数、
                            let layer_number = JSON.parse(JSON.stringify(item.layer_number));
                            if(item.width_other==''||item.width_other==undefined){
                                total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                                total += !!item.width&&item.width.length>0?",":"";
                            }else{//均宽余数有数据时，总宽度=（宽度明细合计/输入宽度个数）*层数+均宽余数
                                if(layer_number!=''){
                                    total += !!item.width&&item.width.length>0?
                                    this.rounding(this.$bc_add(this.$bc_mul(this.$bc_div(this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))),item.width.length),item.layer_number),item.width_other))
                                    :"";
                                    total += !!item.width&&item.width.length>0?",":"";
                                }else{
                                    total = item.width_other;
                                    total += !!item.width&&item.width.length>0?",":"";
                                }
                            }
                        // }else{
                            //     total += !!item.width&&item.width.length>0?this.keepLimit(item.width.reduce((prev,next)=>this.keepLimit( Number(prev)+Number(next)))):"";
                        //     total += !!item.width&&item.width.length>0?",":"";
                        // }
                    }
                            // if(item.layer_number){
                })
                if(this.sameType == 1){
                    if(layer_number==0){
                        total = String(this.keepLimit(total.substring(0,total.length-1)));
                    }else{
                        if(countWidth){
                            total = String(this.keepLimit(total.substring(0,total.length-1)/countWidth*(layer_number?layer_number:1)));
                        }else{
                            total = String(this.keepLimit(total.substring(0,total.length-1)));
                        }
                    }
                }else{
                    total = String((total.substring(0,total.length-1)));
                }
                this.form_params.in.detail[formNumber].sales_width_total = total;
            },
            calculation(formNumber){
                this.calculationTotalWidth(formNumber)
                this.calculationSalesWidthTotalWidth(formNumber)
                let keepIndex = ",";
                let removeIndex = ",";
                this.form_params.in.detail[formNumber].width.forEach((item,index)=>{
                    if(item.width.length>0){
                        keepIndex += index+",";
                    }else{
                        removeIndex += index+",";
                    }
                })
                this.form_params.in.detail[formNumber].sales_width.forEach((item,index)=>{
                    if(item.width.length>0){
                        keepIndex += index+",";
                    }else{
                        removeIndex += index+",";
                    }
                })
                let number = formNumber==1?number=0:number=1;
                let otherList = JSON.parse(JSON.stringify(this.removeOriginal));
                // let otherSalesWidthList = JSON.parse(JSON.stringify(this.removeSalesWidthOriginal));
                if(this.removeThicknessOriginal.split(",").length==1){
                    let inData = 0;
                    let inSalesWidthData = 0;
                    if(this.form_params.in.detail[formNumber].width.length>0){
                        inData = (this.form_params.in.detail[formNumber].width[0].width).reduce((prev,next)=>{
                            return Number(prev)+Number(next)
                        })
                    }
                    // if(this.form_params.in.detail[formNumber].sales_width.length>0){
                    //     inSalesWidthData = (this.form_params.in.detail[formNumber].width[0].width).reduce((prev,next)=>{
                    //         return Number(prev)+Number(next)
                    //     })
                    // }
                    let cha = Number(this.removeTotalOriginal) - Number(inData)
                    // let chaSalesWidth = Number(this.removeSalesWidthTotalOriginal)- Number(inSalesWidthData)
                    if(otherList.length>0){
                        otherList[0].width = [];
                        otherList[0].width[0] = cha;
                    }
                    // if(otherSalesWidthList.length>0){
                    //     otherSalesWidthList[0].width = [];
                    //     otherSalesWidthList[0].width[0] = chaSalesWidth;
                    // }
                }else{
                    this.removeOriginal.forEach((item,index)=>{
                        if(removeIndex.indexOf(","+index+",")!=-1){
                            // otherList.push(JSON.parse(JSON.stringify(item)))
                            otherList[index].width = item.width;
                        }else{
                            otherList[index].width = [];
                        }
                    })
                    // this.removeSalesWidthOriginal.forEach((item,index)=>{
                    //     if(removeIndex.indexOf(","+index+",")!=-1){
                    //         otherList[index].width = item.width;
                    //     }else{
                    //         otherList[index].width = [];
                    //     }
                    // })
                    // this.pl(otherList)
                }
                // if(this.transferType ==2 && formNumber==0){
                //     this.form_params.in.detail[number].width = otherList;
                //     this.calculationTotalWidth(number);
                //     this.changeOtherData(number,removeIndex);
                //     this.calculationCube(number);
                // }
                this.calculationCube(formNumber);
                this.changeOtherData(formNumber,keepIndex);
                this.upodateType = 3;
            },
            //点击总宽度
            widthClick(row,index){
                this.widthList = JSON.parse(JSON.stringify(row.width));
                this.dialogVisibleWidth=true;
                this.isCanEditTotalWidth=true;
                this.indetailType=index;
                this.isCanEditTotalWidth=!this.isCanEdit?true:false;
                // transferType==1?isCanEditTotalWidth=true:(scope.$index==0&&upodateType==2&&!isCanEdit)||(scope.$index==1&&upodateType==3&&!isCanEdit)?isCanEditTotalWidth=true:isCanEditTotalWidth=false;
            },
            //点击销售总宽度
            salesWidthClick(row,index){
                this.widthList = JSON.parse(JSON.stringify(row.sales_width));
                this.saleDialogVisibleWidth=true;
                this.isSaleCanEditTotalWidth=true;
                this.indetailType=index;
                this.isSaleCanEditTotalWidth=!this.isCanEdit?true:false;
            },
            changeOtherData(formNumber,keepIndex){
                return
                let thicknessList = this.removeThicknessOriginal.split(",");
                if(thicknessList.length>1){
                    let lengthList = this.removeLengthOriginal.split(",");
                    let piecesList = this.removePiecesOriginal.split(",");
                    let thickness = "";
                    let length = "";
                    let pieces = "";
                    thicknessList.forEach((item,index)=>{
                        if(keepIndex.indexOf(","+index+",")!=-1){
                            thickness += thicknessList[index] + ",";
                            length += lengthList[index] + ",";
                            pieces += piecesList[index] + ",";
                        }
                    })
                    this.form_params.in.detail[formNumber].original_thickness = thickness.substring(0,thickness.length-1);
                    this.form_params.in.detail[formNumber].original_length = length.substring(0,length.length-1);
                    this.form_params.in.detail[formNumber].pieces = pieces.substring(0,pieces.length-1);
                }
            },
            calculationCube(formNumber){
                // let cal_cube = 0;
                // let thickness = this.form_params.in.detail[formNumber].original_thickness.split(",");
                // let length = this.form_params.in.detail[formNumber].original_length.split(",");
                // let widthT = this.form_params.in.detail[formNumber].original_width_total.split(",");
                // widthT.forEach((item,index)=>{
                    //     cal_cube += (Number(thickness[index])/100)*length[index]*(Number(widthT[index])/100)//码单立方计算
                // })
                // this.form_params.in.detail[formNumber].original_cube = this.keepLimit(cal_cube);//，码单立方
                if(this.form_params.in.detail[formNumber].original_width_total){
                    let arr = this.form_params.in.detail[formNumber].width;
                    let newThickness = arr.map(a=>{
                        return a.thickness//厚度
                    })
                    let newLength = arr.map(a=>{
                        return a.length//长度
                    })
                    //码单立方
                    let newArr = arr.map(a=>{
                        return Number(a.cube)
                    })
                    let newCube = newArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //层数 
                    let layer_numberArr = arr.map(a=>{
                        return Number(a.layer_number)
                    })
                    let newlayer_number = layer_numberArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //片数
                    let piecesArr = arr.map(a=>{
                        return Number(a.pieces)
                    })
                    let newpieces = piecesArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0);
                    this.form_params.in.detail[formNumber].original_thickness = String(newThickness);//厚度
                    this.form_params.in.detail[formNumber].original_length = String(newLength);//长度
                    this.form_params.in.detail[formNumber].original_cube = this.keepLimit(newCube);//，码单立方
                    this.form_params.in.detail[formNumber].layer_number = newlayer_number;//层数
                    this.form_params.in.detail[formNumber].pieces = newpieces;//片数
                }else{
                    let cal_cube = 0;
                    let thickness = this.form_params.in.detail[formNumber].original_thickness.split(",");
                    let length = this.form_params.in.detail[formNumber].original_length.split(",");
                    let widthT = this.form_params.in.detail[formNumber].original_width_total.split(",");
                    widthT.forEach((item,index)=>{
                            cal_cube += (Number(thickness[index])/100)*length[index]*(Number(widthT[index])/100)//码单立方计算
                    })
                    this.form_params.in.detail[formNumber].original_cube = this.keepLimit(cal_cube);//，码单立方
                }
                if(this.form_params.in.detail[formNumber].sales_width_total){
                    let salesArr = this.form_params.in.detail[formNumber].sales_width;
                    let newThickness = salesArr.map(a=>{
                        return a.thickness//厚度
                    })
                    let newLength = salesArr.map(a=>{
                        return a.length//长度
                    })
                    //码单立方
                    let newArr = salesArr.map(a=>{
                        return Number(a.cube)
                    })
                    let newCube = newArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //层数 
                    let layer_numberArr = salesArr.map(a=>{
                        return Number(a.layer_number)
                    })
                    let newlayer_number = layer_numberArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0); 
                    //片数
                    let piecesArr = salesArr.map(a=>{
                        return Number(a.pieces)
                    })
                    let newpieces = piecesArr.reduce(function(a, b){
                        if(b){
                            return a + b; 
                        }else{
                            return a
                        }
                    }, 0);
                    // this.form_params.in.detail[formNumber].original_thickness = String(newThickness);//厚度
                    // this.form_params.in.detail[formNumber].original_length = String(newLength);//长度
                    this.form_params.in.detail[formNumber].sales_cube = this.keepLimit(newCube);//，销售立方
                    // this.form_params.in.detail[formNumber].layer_number = newlayer_number;//层数
                    // this.form_params.in.detail[formNumber].pieces = newpieces;//片数
                }
                // else{
                //     let cal_cube = 0;
                //     let thickness = this.form_params.in.detail[formNumber].original_thickness.split(",");
                //     let length = this.form_params.in.detail[formNumber].original_length.split(",");
                //     let widthT = this.form_params.in.detail[formNumber].original_width_total.split(",");
                //     widthT.forEach((item,index)=>{
                //             cal_cube += (Number(thickness[index])/100)*length[index]*(Number(widthT[index])/100)//码单立方计算
                //     })
                //     this.form_params.in.detail[formNumber].original_cube = this.keepLimit(cal_cube);//，码单立方
                // }
            },
            listDetailInAdd(){
                let data = JSON.parse(JSON.stringify(this.form_params.in.detail[0]))
                data.original_cube = "";
                this.form_params.in.detail.push(data)
            },
            listDetailInDelete(index){
                this.form_params.in.detail.splice(index,1)
                if(this.form_params.in.detail.length<=0){
                    this.form_params.in.detail.push({id:"",bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",check_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:"",weight:"",one_width:"",zel_total_width:"",avg_width:"",})
                }
                this.transferNumber=this.form_params.in.detail.length;
            },
            toProduct(){
                this.dialogVisibleStock=!this.dialogVisibleStock;
                this.form_params.in.detail =[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                color_id:"",
                                attribute_id:"",
                                sales_price:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                width:[
                                   {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[],width_other:""}
                                ],
                                pieces:"",
                                original_cube:"",
                                check_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:"",
                                indexs:"",
                                is_sales:'',
                                weight:"",
                                one_width:"",
                                zel_total_width:"",
                                avg_width:"",
                            }
                        ]
                
            },
            listDetailDelete(index){
                this.form_params.out.detail.splice(index,1)
                if(this.form_params.out.detail.length<=0){
                    this.form_params.out.detail.push({id:"",bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",check_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:"",weight:"",one_width:"",zel_total_width:"",avg_width:"",})
                }
                this.form_params.in.detail =[
                            {
                                id:"",
                                bale_no:"",
                                brand_id:"",
                                brand:"",
                                breed:"",
                                breed_id:"",
                                grade_id:"",
                                grade:"",
                                color_id:"",
                                attribute_id:"",
                                sales_price:"",
                                original_thickness:"",
                                original_length:"",
                                original_width_total:"",
                                width:[
                                   {cube:0,layer_number:0,length:"0",spec:"",thickness:"0",veneer_avg:"",width:[],width_other:""}
                                ],
                                pieces:"",
                                original_cube:"",
                                check_cube:"",
                                sales_cube:"",
                                cube_price:"",
                                cost:"",
                                cost_price:"",
                                ship_no:"",
                                status:"",
                                warehouse:"",
                                warehouse_id:"",
                                remark:"",
                                status_text:"",
                                indexs:"",
                                is_sales:'',
                                weight:"",
                                one_width:"",
                                zel_total_width:"",
                                avg_width:"",
                            }
                        ]
            },
            reset(){
                this.start_time="";
                this.end_time="";
                this.params={search:{start_time:"",end_time:"",sn:"",status:""},page:1,per_page:50}
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time=this.formatTimeZero(this.start_time);
                this.params.end_time=this.formatTimeZero(this.end_time);
                this.tableLoading = true;
                this.$postColumnList("/erp/assembly.list",this.params,res=>{
                    this.totalObj=res.data.data.total;
                    this.filter = res.data.data.column;
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.order_time!=0){
                            this.list[index].order_time = this.formatTime(item.order_time+"000")
                        }else{
                            this.list[index].order_time = "";
                        }
                    })
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            excelExport(){
                this.$exportExecl("/erp/assembly.export","组装拆卸",this.params)
            },
            //选择库存信息
            selectData(row){
                this.listDetailSet(row)
            },
            selectAndOut(row){
                this.listDetailSet(row)
                this.dialogVisibleStock = !this.dialogVisibleStock;
            },
            listDetailSet(row){
                let rows=JSON.parse(JSON.stringify(row));
                rows.forEach(item=>{
                    item.color_id = item.color_id == 0 ? '' : item.color_id
                    item.attribute_id = item.attribute_id == 0 ? '' : item.attribute_id
                })
                // rows.forEach(item=>{
                //     item.inventory_id=item.id;
                //     item.id="";
                //     item.totalPrice=parseFloat(Number(item.sales_cube)*Number(item.sales_price)).toFixed(2)
                // })
                if(rows.length<=0){
                    return;
                }
                if(this.form_params.out.detail.length==1){
                    if(this.form_params.out.detail[0].id==""){
                        this.form_params.out.detail=rows;
                        return;
                    }
                }
                this.form_params.out.detail=this.form_params.out.detail.concat(rows)
                let result = [];
                let obj = {};
                let data=JSON.parse(JSON.stringify(this.form_params.out.detail))
                for(var i =0; i<data.length; i++){
                    if(!obj[data[i].id]){
                        result.push(data[i]);
                        obj[data[i].id] = true;
                    }
                }
                this.form_params.out.detail=result;
                this.transferType="";
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(obj){
                this.sceneIn = 'assembly.create.column';
                this.isGlobal = true;
                this.getBillColumn();
                this.postFunc("/erp/assembly.view",{id:obj.id},res=>{
                    this.form_params.out.detail=res.data.data.out;
                    this.form_params.in.detail=res.data.data.in;
                    this.form_params.remark=res.data.data.info.remark;
                    this.form_params.order_time = this.formatTime(res.data.data.info.order_time+"000");
                    this.form_params.creator_name = res.data.data.info.creator_name;
                    this.dialogVisible=true;
                    this.isCanEdit=true;
                },()=>{})
            },
            getRow(row){
                this.selectRow=row;
            },
            selectionDetailChange(row){
                // row.forEach((val,index)=>{
                //     this.form_params.in.detail.forEach((v, i) => {
                //         if(val.id = v.id){
                //             this.selectionDetailIndex = i;
                //         }
                //     })
                // })
                this.selectionDetailRow=row;
            },
            toggleSelection(row) {
                this.$refs.listDetailTable.toggleRowSelection(row);
            },
            checkSelectable(row){
                return true;
            },
            //打开重新检尺
            recheckRuler(){
                if(this.selectionDetailRow.length>=2){
                    this.tip('请选择单条数据检尺',"warning");
                    return
                }else if(this.selectionDetailRow.length==0){
                    this.tip('请选择数据',"warning");
                    return
                }else if(this.selectionDetailRow.length==1){
                    if(this.form_params.out.detail[0].category_id==2&&this.form_params.out.detail[0].original_width_total!=0){
                        this.widthList = JSON.parse(JSON.stringify(this.selectionDetailRow[0].sales_width));
                        this.isSaleCanEditTotalWidth = true;
                        this.saleRulerDialogVisibleWidth = true;
                        // this.$confirm('非洲材是按公式计算立方的，是否确定要检尺~！(检尺后按检尺立方当做销售立方)', '提示', {
                        //     confirmButtonText: '确定',
                        //     cancelButtonText: '取消',
                        //     type: 'warning'
                        // }).then(()=>{
                        //     this.rulerSpringFrame = !this.rulerSpringFrame;
                        //     this.rulerForm.bale_no = this.selectionDetailRow[0].bale_no;
                        //     this.rulerForm.original_cube = this.selectionDetailRow[0].original_cube;
                        //     this.rulerForm.check_cube = this.selectionDetailRow[0].check_cube;
                        //     this.rulerForm.sales_cube = this.selectionDetailRow[0].sales_cube;
                        // }).catch(()=>{});
                    }else{
                        this.rulerSpringFrame = !this.rulerSpringFrame;
                        this.rulerForm.bale_no = this.selectionDetailRow[0].bale_no;
                        this.rulerForm.original_cube = this.selectionDetailRow[0].original_cube;
                        this.rulerForm.check_cube = this.selectionDetailRow[0].check_cube;
                        this.rulerForm.sales_cube = this.selectionDetailRow[0].sales_cube;
                    }
                }
            },
            //是否同时修改销售总宽度返回
            // returnIs_sales(res){
            //     this.form_params.in.detail[1].is_sales = res;
            // },
            //总宽度返回
            widthReturn(res){
                this.salesEditDialog = true;
                this.salesEditContent = res;
                // if(this.is_sales==true){
                //     this.saleWidthReturn(res)
                // }
                // this.form_params.in.detail[this.indetailType].width=res;
                // this.calculation(this.indetailType);
                // // 返回后总宽度计算
                // if(this.transferType==2&&this.form_params.in.detail[0].width.length==1&&this.indetailType==0){
                //     this.form_params.in.detail[1].original_width_total = this.$bc_sub(this.form_params.out.detail[0].original_width_total,this.form_params.in.detail[0].original_width_total);
                //     this.form_params.in.detail[1].original_cube = this.$bc_sub(this.form_params.out.detail[0].original_cube,this.form_params.in.detail[0].original_cube);
                //     this.form_params.in.detail[1].width.forEach(item=>{
                //         item.width = [this.form_params.in.detail[1].original_width_total];
                //     })
                // }
            },
            widthEdit(res){
                this.form_params.in.detail[this.indetailType].width=res;
                this.calculation(this.indetailType);
                // 返回后总宽度计算
                if(this.selectStatus==0&&this.transferType==2&&this.form_params.in.detail[0].width.length==1&&this.indetailType==0){
                    this.form_params.in.detail[1].original_width_total = this.$bc_sub(this.form_params.out.detail[0].original_width_total,this.form_params.in.detail[0].original_width_total);
                    this.form_params.in.detail[1].original_cube = this.$bc_sub(this.form_params.out.detail[0].original_cube,this.form_params.in.detail[0].original_cube);
                    this.form_params.in.detail[1].width.forEach(item=>{
                        item.width = [this.form_params.in.detail[1].original_width_total];
                    })
                }
                if(this.is_sales==true){
                    this.saleWidthReturn(res)
                    
                }
                this.salesEditDialog = false;
            },
            //销售宽度修改返回
            saleWidthReturn(res){
                this.form_params.in.detail[this.indetailType].sales_width=res;
                this.calculation(this.indetailType);
                // 返回后总宽度计算
                if(this.selectStatus==0&&this.transferType==2&&this.form_params.in.detail[0].sales_width.length==1&&this.indetailType==0){
                    this.form_params.in.detail[1].sales_width_total = this.$bc_sub(this.form_params.out.detail[0].sales_width_total,this.form_params.in.detail[0].sales_width_total);
                    this.form_params.in.detail[1].sales_cube = this.$bc_sub(this.form_params.out.detail[0].sales_cube,this.form_params.in.detail[0].sales_cube);
                    this.form_params.in.detail[1].sales_width.forEach(item=>{
                        item.sales_width = [this.form_params.in.detail[1].sales_width_total];
                    })
                }
            },
            //检尺销售宽度修改返回
            saleRulerWidthReturn(res){
                let arr = res;
                let newArr = arr.map(a=>{
                    return Number(a.cube)
                })
                let newCube = newArr.reduce(function(a, b){
                    if(b){
                        return a + b; 
                    }else{
                        return a
                    }
                }, 0); 
                this.form_params.in.detail.forEach(item=>{
                    if(item.indexs==this.selectionDetailRow[0].indexs){
                        item.sales_width = arr;
                        item.check_cube = newCube;
                        item.sales_cube = newCube;
                        // item.sales_width_total =
                    }
                })
            },
            //检尺修改START
            chiCheckCube(val){
                this.rulerForm.sales_cube=Number(val);
            },
            //重新检尺确认
            newRuler(){
                let dl = this.$cloneJson(this.form_params.in.detail);
                let checkData = this.$cloneJson(this.selectionDetailRow).map(item=>(item.bale_no));
                dl.forEach((item,index) => {
                    if(checkData.indexOf(item.bale_no) == -1 ){
                        return
                    }
                    item.check_cube = Number(this.rulerForm.check_cube);
                    item.sales_cube = Number(this.rulerForm.sales_cube);                   
                });
                this.form_params.in.detail = dl;
                this.check = 1;
                this.rulerSpringFrame = !this.rulerSpringFrame;
            }, 
            tableRowClassName({row}) {
                // for(let i=0;i<this.selectionDetailRow.length;i++){
                //     if(this.selectionDetailRow[i].indexs){
                //         if(this.selectionDetailRow[i].indexs==row.indexs){
                //             return 'selectRow';
                //         }
                //     }
                // }
            },
            decimalGet(){
                this.postFunc("/erp/system.get.config",{key:"DECIMAL_CUBE_SCALE"},res=>{
                    this.decimalNum = res.data.data.value==''?4:Number(res.data.data.value);

                    // 设置缓存
                    localStorage.setItem('dm_erp_decimal_scale',this.decimalNum);
                },error=>{
                    
                })
            },
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "dialogVisible":function(val){
                if(!val){
                    //this.form_params=this.resetJson(this.form_params)
                    this.form_params.out.detail=[];
                    this.form_params.in.detail=[];
                    this.form_params.remark="";
                    this.transferType=''
                    let obj = {id:"",bale_no:"",brand_id:"",brand:"",breed:"",breed_id:"",grade_id:"",grade:"",original_thickness:"",original_length:"",original_width_total:"",pieces:"",original_cube:"",check_cube:"",sales_cube:"",cube_price:"",cost:"",cost_price:"",ship_no:"",status:"",warehouse:"",warehouse_id:"",remark:"",status_text:""}
                    this.form_params.out.detail.push(JSON.parse(JSON.stringify(obj)))
                    this.form_params.in.detail.push(JSON.parse(JSON.stringify(obj)))
                    this.check = 0;
                    this.isCanEdit=false;
                    this.categoryEdit=true;
                }else{
                    this.decimalGet();
                }
            },
            "dialogVisibleStock":function(val){
                if(!val){
                    this.$refs.selectStock.resetSelect();
                    this.is_sales=true;
                }
            },
            "centerDialogVisible":function(val){
                if(!val){
                    this.refuse=this.resetJson(this.refuse)
                }
            },
            "rulerSpringFrame":function(val){
                if(!val){
                    this.rulerForm=this.resetJson(this.rulerForm)
                }
            },
        }
    }
</script>
<style scoped lang="scss">
    .outAndInTitle{padding:10px 0;}
    // dialog START
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .eldialogBack.eldialogC .dialogFlow{max-height: unset}
    .eldialogBack .remarkBox{width:1090px;box-sizing: border-box;}
    .transferType{padding:10px 0;}
    .transferNumber{display: inline-block;}
    .transferNumberInput{width:150px;height: 33px;line-height: 33px;font-size: 12px;border-radius: 3px;border:1px solid #ccc;outline: none;padding:0 10px;}
    // dialog ENDout
    .gaugeBtn{float:right;padding: 0px 0px;width: 90px;color: #fff;font-size: 13px; border-radius: 3px; line-height: 31px;cursor: pointer;margin-right: 15px;font-weight: 600;background-color: #F7A502;}
    .beCareful{color: red;padding: 10px;}
    .flex{display: flex;}
    .flex div{padding-right: 20px}
</style>